export default "__VITE_ASSET__DA0LcDC1__"